import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

import { useMedia } from '..';

export function ProgressBar(progressBarProps: ComponentProps<'div'>) {
  const { duration, currentTime, currentPercentage, bufferedPercentage, seek } = useMedia();
  const { className, ...props } = progressBarProps;
  return (
    <div className={cn('group/progress relative flex flex-1', className)} {...props}>
      <div
        className="bg-gray/50 absolute inset-0 h-1 rounded-full transition-all duration-150"
        style={{
          width: `${duration > 0 ? bufferedPercentage : 0}%`,
        }}
      />
      <input
        type="range"
        min={0}
        max={duration || 0}
        step={0.1}
        value={currentTime}
        onChange={(e) => {
          e.stopPropagation();
          seek(Number.parseFloat(e.target.value));
        }}
        className="bg-gray/30 [&::-webkit-slider-thumb]:bg-gray [&::-webkit-slider-thumb]: z-10 h-1 w-full cursor-pointer appearance-none rounded-full [&::-webkit-slider-thumb]:h-4 [&::-webkit-slider-thumb]:w-4 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:transition-all [&::-webkit-slider-thumb]:duration-150 group-hover/progress:[&::-webkit-slider-thumb]:scale-125 md:[&::-webkit-slider-thumb]:h-3 md:[&::-webkit-slider-thumb]:w-3"
        style={{
          background: `linear-gradient(to right, var(--color-gray) 0%, var(--color-gray) ${currentPercentage}%, rgb(from var(--color-gray) r g b / 0.2) ${
            currentPercentage
          }%, rgb(from var(--color-gray) r g b / 0.2) 100%)`,
        }}
      />
    </div>
  );
}
